// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.choose-message-content-type-dialog__container {
    position: relative;
    top: 6px;
    cursor: pointer;
}

.choose-message-content-type__menu-item {
    cursor: pointer;
    text-align: left;
    padding: 1rem 2rem;
    display: flex;
}

.choose-message-content-type__menu-item:hover {
    background: #26a69a;
    color: #fff;
}

.choose-message-content-type-dialog__menu {
    position: absolute;
    display: block;
    min-width: 4rem;
    bottom: 2rem;
    text-align: center;
    background-color: white;
    box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);
    border-radius: 4px;
    z-index: 100;
}

.choose-message-content-type-dialog__dropdown-image {
    margin-right: 10px;
}

.choose-message-content-type-dialog__image {    
    opacity: 0.7;
}

.choose-message-content-type-dialog__image:hover {    
    opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/choose-message-content-type-dialog/ChooseMessageContentType.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,uGAAuG;IACvG,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd","sourcesContent":[".choose-message-content-type-dialog__container {\r\n    position: relative;\r\n    top: 6px;\r\n    cursor: pointer;\r\n}\r\n\r\n.choose-message-content-type__menu-item {\r\n    cursor: pointer;\r\n    text-align: left;\r\n    padding: 1rem 2rem;\r\n    display: flex;\r\n}\r\n\r\n.choose-message-content-type__menu-item:hover {\r\n    background: #26a69a;\r\n    color: #fff;\r\n}\r\n\r\n.choose-message-content-type-dialog__menu {\r\n    position: absolute;\r\n    display: block;\r\n    min-width: 4rem;\r\n    bottom: 2rem;\r\n    text-align: center;\r\n    background-color: white;\r\n    box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);\r\n    border-radius: 4px;\r\n    z-index: 100;\r\n}\r\n\r\n.choose-message-content-type-dialog__dropdown-image {\r\n    margin-right: 10px;\r\n}\r\n\r\n.choose-message-content-type-dialog__image {    \r\n    opacity: 0.7;\r\n}\r\n\r\n.choose-message-content-type-dialog__image:hover {    \r\n    opacity: 1;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
